import { type ColumnsState, createColumnsHook } from '@features/allocation';

/** Ordem de exibição. "Nome" fica de fora: é o que identifica a linha, sempre visível. */
export const ALLOCATION_TAG_COLUMNS = ['color', 'active', 'allocationCount'] as const;

export type AllocationTagColumn = (typeof ALLOCATION_TAG_COLUMNS)[number];

/** Chaves do namespace `tagsAlocacao`. */
export const ALLOCATION_TAG_COLUMN_LABEL_KEYS = {
  color: 'colunas.cor',
  active: 'colunas.ativa',
  allocationCount: 'colunas.alocacoes',
} as const satisfies Record<AllocationTagColumn, string>;

export const useAllocationTagColumns = createColumnsHook({
  columns: ALLOCATION_TAG_COLUMNS,
  defaultColumns: ALLOCATION_TAG_COLUMNS,
  storageKey: 'allocation-tags-table-columns',
  version: 1,
});

export type AllocationTagColumnsState = ColumnsState<AllocationTagColumn>;
